/**
 * Persistenza della `sessionPolicy` (DTO condiviso, secondi) ricevuta da
 * login/refresh e conversione nelle durate del motore `session-idle`.
 * Le durate NON sono costanti del frontend: `DEFAULT_SESSION_POLICY` è
 * l'unico fallback quando nulla è persistito.
 */
import { sessionPolicySchema, type SessionPolicy } from '@easyflow/shared';
import {
  DEFAULT_SESSION_POLICY,
  sessionPolicyToConfig,
  type SessionDurations,
} from '@easyflow/ui-frontend';
import { AUTH_STORAGE_KEYS } from '@/constants/auth';

export function persistSessionPolicy(policy: SessionPolicy): void {
  localStorage.setItem(AUTH_STORAGE_KEYS.SESSION_POLICY, JSON.stringify(policy));
}

/** Policy persistita e valida secondo lo schema condiviso, altrimenti null. */
export function readStoredSessionPolicy(): SessionPolicy | null {
  const raw = localStorage.getItem(AUTH_STORAGE_KEYS.SESSION_POLICY);
  if (raw === null) return null;
  let parsedJson: unknown;
  try {
    parsedJson = JSON.parse(raw);
  } catch {
    return null;
  }
  const result = sessionPolicySchema.safeParse(parsedJson);
  return result.success ? result.data : null;
}

/** Durate effettive per lo store: policy persistita o default condiviso. */
export function resolveSessionDurations(): SessionDurations {
  const stored = readStoredSessionPolicy();
  return stored ? sessionPolicyToConfig(stored) : DEFAULT_SESSION_POLICY;
}
